/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState, useEffect } from 'react'
import Modal from '@/components/Modal'
import { validateRegex } from '@/lib/utilities/FormValidation'
import useIsMobile from '@/hooks/useIsMobile'
import appDownloadApis from '@/apis/landing-page'

interface WebToAppPopupProps {
  isOpen: boolean
  onClose: () => void
}

const WebToAppPopup = ({
  isOpen,
  onClose
}: WebToAppPopupProps) => {
  // if (!isOpen) return null
  const isMobile = useIsMobile()

  const [phoneNumber, setPhoneNumber] = useState('')
  const [submitStatus, setSubmitStatus] = useState<'loading' | 'success' | 'error' | ''>()
  const [submitError, setSubmitError] = useState('')
  const [isPhoneDisabled, setIsPhoneDisabled] = useState(true)

  const appUrlLink = 'https://llocal.onelink.me/ALsT/webtoapp'
  const onHidePromotionPopup = () => {
    onClose()
  }

  const handleSubmit = (): void => {
    setSubmitStatus('loading')
    appDownloadApis.sendSMSForAppDownload({ phoneNumber }).then(() => {
      setSubmitStatus('success')
      setTimeout(() => {
        setSubmitStatus('')
        setPhoneNumber('')
        if (isMobile) {
          window.open(appUrlLink, '_blank')
        }
        onClose()
      }, 2000)
    }).catch((err) => {
      setSubmitStatus('')
      if (err?.response?.status === 400) {
        setSubmitError(err?.response?.data?.errors?.[0]?.message)
      } else {
        setSubmitError('Oops! Something went wrong.')
      }
    })
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  useEffect(() => {
    setIsPhoneDisabled(!(phoneNumber.length === 10 && validateRegex('phoneNumber', phoneNumber)))
  }, [phoneNumber])

  return (
    <Modal
      show={isOpen}
      onHide={onHidePromotionPopup}
      size="lg"
      bodyStyle={
        typeof window !== 'undefined' && window.innerWidth <= 768
          ? {
              left: 0,
              /* top: 100%; */
              background: 'transparent',
              scrollbarWidth: 'none',
              width: '100%',
              /* border-top-left-radius: 24px; */
              /* border-top-right-radius: 24px; */
              /* opacity: 1; */
              /* transition: transform 0.3s ease-in-out; */
              /* height: 100vh; */
              bottom: 0,
              transform: 'translate(0%, 0%)'
            }
          : {
              left: '50%',
              top: '60%',
              transform: 'translate(-50%, -50%)',
              background: 'transparent',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              minHeight: '700px'
            }
      }
    >
      {/* Close button */}
      <button
        type="button"
        aria-label="Close button"
        onClick={onHidePromotionPopup}
        className="absolute top-5 right-6 z-50 h-[34px] w-[34px] bg-transparent hover:bg-transparent focus:outline-none"
      >
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="16.6667" fill="#E5E5E5"/>
          <path d="M26.6667 13.3333L13.3334 26.6667M13.3334 13.3333L26.6667 26.6667" stroke="black" strokeWidth="2"
                strokeLinecap="round"/>
        </svg>
      </button>

      {/* Popup container */}
      <div
        className="w-[100%] max-w-[880px] h-auto max-h-[90vh] mx-auto bg-[#D81DA4] md:rounded-[40px] overflow-y-auto rounded-tl-[24px] rounded-tr-[24px]">

        {/* Top banner section */}
        <div className="flex flex-row items-start justify-between rounded-t-[40px] overflow-hidden bg-[#D81DA4] p-4">
          {/* Left content */}
          <div className="flex-1 text-white flex flex-col justify-start">
            <h2
              className="font-extrabold text-[22px] leading-[26px] md:text-[28px] md:leading-[28px] capitalize font-montserrat">
              Guaranteed Freshness
              <br/>
              From Your
              <br/>
              Trusted Local Stores
            </h2>

            {/* Offer image */}
            <div className="mt-6 md:mt-4">
              <img
                src="/images/app-download-offer-banner.png"
                alt="30% off upto ₹100 + Free delivery"
                className="max-w-[250px] md:max-w-[303px] w-full"
              />
            </div>
          </div>

          {/* Right illustration */}
          <div className="flex-shrink-0 ml-4">
            <img
              src="/images/mobile-banner.png"
              alt="Mobile Banner"
              className="w-[200px] h-auto md:hidden"
            />
            <div
              className="hidden md:block md:w-[474px] md:h-[250px] bg-[url('/images/banner-popup-bg.png')] bg-cover bg-center rounded-[40px]"/>
          </div>
        </div>

        {/* Download button (mobile only) */}
        <div className="md:hidden flex items-center justify-center px-4">
          <button
            onClick={() => window.open(appUrlLink, '_blank')}
            className="w-full my-4 flex items-center justify-center px-14 py-4 rounded-xl bg-white text-[#D81DA4] font-extrabold text-[15px] leading-[19px]"
          >
            Download The App Now
            <div className="ml-2 flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM14.0657 7.93432C13.7533 7.6219 13.2467 7.6219 12.9343 7.93432C12.6219 8.24673 12.6219 8.75327 12.9343 9.06569L15.0686 11.2H8.00001C7.55818 11.2 7.20001 11.5582 7.20001 12C7.20001 12.4418 7.55818 12.8 8.00001 12.8H15.0686L12.9343 14.9343C12.6219 15.2467 12.6219 15.7533 12.9343 16.0657C13.2467 16.3781 13.7533 16.3781 14.0657 16.0657L17.5657 12.5657C17.8781 12.2533 17.8781 11.7467 17.5657 11.4343L14.0657 7.93432Z"
                  fill="#B8238E"
                />
              </svg>
            </div>
          </button>
        </div>

        {/* Bottom section */}
        <div className="grid grid-cols-1 md:grid-cols-12 bg-[#9D0B75] rounded-b-[40px] p-6 gap-4 md:grid hidden">
          {/* QR Section */}
          <div className="md:col-span-4 flex flex-col items-center justify-center">
            <h2 className="font-black text-center text-white text-xl mb-4">Download The App</h2>
            <img
              src="/images/qr-code-image.png"
              alt="QR Code"
              className="w-[180px] h-[180px] md:w-[200px] md:h-[200px]"
            />
          </div>

          {/* OR divider */}
          <div className="md:col-span-1 flex items-center justify-center relative">
            <div className="h-full w-[1px] bg-white"></div>
            <div
              className="absolute top-1/2 -translate-y-1/2 w-[40px] h-[32px] rounded-full bg-[#9D0B75] flex items-center justify-center font-extrabold text-white text-[20px]">
              OR
            </div>
          </div>

          {/* Phone Input Section */}
          <div className="md:col-span-7 flex flex-col items-center justify-center">
            <h2 className="text-center font-monserrat font-extrabold text-size-[22px] text-white mb-4 text-xl">
              Get The LoveLocal App <br/> Download Link On SMS
            </h2>
            <input
              type="tel"
              inputMode="numeric"
              placeholder="Enter Your Mobile Number"
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 10)
                setPhoneNumber(value)
                setSubmitError('')
              }}
              maxLength={10}
              className="w-full h-[70px] max-w-[480px] px-4 py-2 rounded-xl border border-white bg-[#9D0B75] text-white placeholder-[#FABDE9] focus:border-blue-400 focus:outline-none"
            />
            <button
              disabled={isPhoneDisabled}
              className={`w-full h-[70px] w-[480px] mt-4 flex items-center justify-center rounded-xl font-extrabold text-lg ${
                isPhoneDisabled
                  ? 'bg-gray-300 text-white'
                  : 'bg-white text-[#B8238E]'
              }`}
              onClick={handleSubmit}
            >
              {submitStatus === 'loading' && (
                <span
                  className="animate-spin border-2 border-t-transparent border-[#B8238E] rounded-full h-5 w-5 mr-2"/>
              )}
              Get Download Link On SMS
            </button>
            {!isMobile && (
              <div className="mt-3 text-center">
                {submitStatus === 'success' && (
                  <p className="text-green-400 font-semibold text-sm">
                    Thanks! Check your SMS inbox for the LoveLocal App download link.
                  </p>
                )}
                {submitError && (
                  <p className="text-white font-semibold text-lg">
                    {submitError}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WebToAppPopup
